import React from 'react';
import './TopHeader.css';
import { generateWhatsAppUrl } from '../utils/whatsapp';

function TopHeader() {
    return (
        <section className="top-header-section">
            <div className="top-header-container">
                {/* Desktop Layout - Address and Phone */}
                <div className="desktop-layout">
                    {/* Left Column - Address */}
                    <div className="top-header-column address-column">
                        <div className="top-header-item">
                            <span className="top-header-icon">
                                <i className="fas fa-map-marked-alt"></i>
                            </span>
                            <span className="top-header-text">Str. 1 Mai, Nr. 294, Petrești-Sebeș</span>
                        </div>
                    </div>

                    {/* Center Column - Marquee */}
                    <div className="top-header-column marquee-column">
                        <div className="marquee-container">
                            <div className="marquee-content">

                            </div>
                        </div>
                    </div>

                    {/* Right Column - Phone/WhatsApp */}
                    <div className="top-header-column phone-column">
                        <div className="top-header-item">
                            <a href={generateWhatsAppUrl('+40 752 875 121')} target="_blank" rel="noopener noreferrer" title="Contactează-ne pe WhatsApp">
                                <span className="top-header-icon">
                                    <i className="fab fa-whatsapp"></i>
                                </span>
                                <span className="top-header-text">WhatsApp: +40 752 875 121</span>
                            </a>
                        </div>
                    </div>
                </div>

                {/* Mobile Layout - WhatsApp only */}
                <div className="mobile-layout">
                    <div className="top-header-column phone-column">
                        <div className="top-header-item">
                            <a href={generateWhatsAppUrl('+40 752 875 121')} target="_blank" rel="noopener noreferrer" title="Contactează-ne pe WhatsApp">
                                <span className="top-header-icon">
                                    <i className="fab fa-whatsapp"></i>
                                </span>
                                <span className="top-header-text">
                                    <i className="fab fa-whatsapp"></i>
                                    +40 752 875 121
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default TopHeader;
